export default __webpack_public_path__ + "static/HTH-homepage-mobile-6e3ebd0c220b4bab387a39631b8a6237.jpg";